import React, { useState, useRef } from 'react'; // ⬅️ Add useRef
import { SaveContext } from '../../contexts/SaveContext';
import TopNavigation from '../TopNav/TopNavigation';
import api from '../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import SlideOver from '../Shared/SlideOver';
import SidebarLeft from '../SidebarLeft';
import SidebarRight from '../SidebarRight';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useSidebar } from '../../contexts/SidebarContext';

export default function EditorLayout({ children }) {
  const [isSaved, setIsSaved] = useState(false);
  const navigate = useNavigate();

  const recipeCardRef = useRef(null); // ✅ Step 1: create the ref
  const handleSaveRef = useRef(null); // 🔁 This will come from RecipeEditor.jsx

  const {
    libraryOpen,
    closeLibrary,
    openLibrary,
    utilitiesOpen,
    closeUtilities,
    openUtilities
  } = useSidebar();

  // Step 2: Replace handleSaveRecipe with this function
  const callHandleSave = async () => {
    if (handleSaveRef.current) {
      try {
        await handleSaveRef.current(); // 🔁 use the actual handleSave from RecipeEditor
        setIsSaved(true);
      } catch (err) {
        console.error("❌ Save failed via SaveContext:", err);
        alert("Failed to save. Try again.");
      }
    } else {
      alert("Save function not available yet.");
    }
  };

  return (
    <SaveContext.Provider value={{ onSave: callHandleSave, isSaved }}>
      {/* ✅ Step 2: pass recipeCardRef to TopNavigation */}
      <TopNavigation
        recipeCardRef={recipeCardRef}
        onOpenLibrary={openLibrary}
        onOpenUtilities={openUtilities}
      />

      <main className="pt-16 overflow-x-hidden">
        {/* 🧬 Inject handleSaveRef into RecipeEditor via children */}
        {React.cloneElement(children, {
          recipeCardRef,
          onSave: handleSaveRef, // 🔁 injects the save ref into RecipeEditor
        })}
      </main>

      {/* SlideOvers for mobile */}
      <SlideOver side="left" open={libraryOpen} onClose={closeLibrary}>
        <SidebarLeft />
      </SlideOver>

      <SlideOver side="right" open={utilitiesOpen} onClose={closeUtilities}>
        <SidebarRight />
      </SlideOver>

      {/* Floating Close Buttons */}
      {libraryOpen && (
        <button
          onClick={closeLibrary}
          className="fixed top-4 right-4 z-50 p-3 bg-white bg-opacity-90 rounded-full shadow-md"
          aria-label="Close library panel"
        >
          <ChevronLeftIcon className="h-6 w-6 text-charcoal" />
        </button>
      )}

      {utilitiesOpen && (
        <button
          onClick={closeUtilities}
          className="fixed top-4 left-4 z-50 p-3 bg-white bg-opacity-90 rounded-full shadow-md"
          aria-label="Close utilities panel"
        >
          <ChevronRightIcon className="h-6 w-6 text-charcoal" />
        </button>
      )}
    </SaveContext.Provider>
  );
}